module.exports = "\r\n.filter-design{\r\n    height: 300px!important;\r\n    overflow-y: scroll;\r\n    margin-top: 2%;\r\n    margin-bottom: 2%\r\n}\r\n\r\n.form-control.selected {\r\n    background-color: lightgrey !important;\r\n}\r\n\r\n/* .datepicker >.form-group{\r\n    margin-bottom: 0px;\r\n} */\r\n\r\n.form-group.date{\r\n    margin-bottom: 0px;\r\n}\r\n\r\nlabel{\r\n    font-size: 12px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/el-data-management/eldm-filters/eldm-filters.component.css
// module id = ./src/app/modules/el-data-management/eldm-filters/eldm-filters.component.css
// module chunks = main